/** @format */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import LabelTextArea from "../../../../shared/components/labelTextArea";
import UploadFile from "../../../../shared/components/uploadFile";
import PortalBackButton from "../PortalBackButton";
import { postCase } from "../../services/claimService";
import { useNavigate } from "fusion-plugin-react-router";
import { getForeName } from "../../../../shared/utils/userSessionUtils";
import { formatDateT } from "../../../../shared/utils/formatters";
import NewDateTimePicker from "../../../../shared/components/newDateTimePicker";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import ReportClaimSuccess from "./ReportClaimSuccess";

const ReportClaimForm = () => {
  const {
    handleSubmit,
    watch,
    register,
    setValue,
    trigger,
    control,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      explaination: "",
      IncidentDateTime: null,
    },
    mode: "onChange",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [userSession, setUserSession] = useState(null);
  const STATE = useAppStateStore();
  const navigate = useNavigate();
  const user = getForeName();
  const insurer = STATE.customerPolicies?.customerPolicies?.[0]?.insurer;

  useEffect(() => {
    const sessionData = sessionStorage.getItem("userSession");
    if (sessionData) {
      setUserSession(JSON.parse(sessionData));
    }
  }, []);

  const onSubmit = async () => {
    setLoading(true);
    setSuccess(false);
    const requestBody = {
      Incident_DateTime__c: formatDateT(watch("IncidentDateTime")),
      Incident_Description__c: watch("explaination"),
      ContactId: userSession?.salesforceContactId,
      Priority: "High",
      Origin: "Web",
      Type: "Claims",
      Reason_for_case__c: "New Claim Reported",
      recordTypeId: "012Vh000000bleHIAQ",
      Date_to_Action__c: new Date().toISOString(),
    };
    try {
      await postCase({ requestBody, navigate, setLoading });
      setSuccess(true);
    } catch (e) {
      console.error("An error occurred while reporting the claim:", e);
      setLoading(false);
    }
  };

  if (success) {
    return <ReportClaimSuccess onBack={() => navigate("/landing")} />;
  }

  return (
    <>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-10">Report a Claim</h1>
        <p className={`gray-text ${!insurer ? "margin-bottom-30" : ""}`}>
          Hi <span className="capitalize">{user}</span>, please complete the
          form below to report a claim. Our team will be in touch with you as
          soon as possible.
        </p>

        {insurer === "Sabre Insurance Company Ltd" && (
          <p className="errorField margin-bottom-30">
            If you require roadside assistance. Please call 01621 737253 as soon
            as possible
          </p>
        )}

        {insurer === "AXA Insurance UK PLC" && (
          <p className="errorField margin-bottom-30">
            If you require roadside assistance. Please call 441737334952 as soon
            as possible
          </p>
        )}
        <form onSubmit={handleSubmit(onSubmit)}>
          <NewDateTimePicker
            name="IncidentDateTime"
            label="Date and time of the accident"
            errors={errors.IncidentDateTime}
            setValue={setValue}
            control={control}
            rules={{ required: "Date is required" }}
            watch={watch}
            defaultValue={watch("IncidentDateTime")}
            maxDate={new Date()}
          />
          <LabelTextArea
            id="explaination"
            label="Brief explanation of the accident"
            placeholder="Enter details"
            register={register("explaination", {
              required: "Comments are required",
            })}
            errors={errors.explaination}
            watch={watch("explaination")}
            trigger={trigger}
            maxLength={500}
          />
          <UploadFile
            id="explaination"
            label="Upload any images or videos of the accident below"
            errors={errors.explaination}
            trigger={trigger}
            maxLength={500}
          />
          <button
            type="submit"
            className={`getStartedButton${!isValid ? " disabledBtn" : ""}`}
            disabled={loading || !isValid}
          >
            {loading ? "Submitting..." : "Submit Claim Details"}
          </button>
        </form>
      </QuoteFormWrapper>
      <PortalBackButton />
    </>
  );
};

export default ReportClaimForm;
